import styled from 'styled-components';
import { SectionContent } from '../sharedStyles.js';

export const StyledSection = styled.div`
  align-items: flex-end;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  height: calc(100vh - 76px);
  justify-content: center;
  margin: 0 auto;
  max-width: 1900px;
  opacity: ${(props) => (props.visible ? '1' : '1')};
  overflow: hidden;
  position: relative;
  transition: all 600ms ease-in-out;
  width: 100%;

  ::before {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(0, 0, 0, 0.35)
    );
    bottom: 0;
    content: '';
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
  @media (min-width: 800px), (min-device-width: 768px) {
    justify-content: flex-start;
    height: calc(100vh - 90px);
  }
  @supports (-webkit-overflow-scrolling: touch) {
    @media (min-device-width: 414px) and (max-device-width: 736px) and (orientation: portrait) {
      /* iPhone 6S+ */
      height: 560px;
    }
  }
`;

export const IntroSectionContent = styled(SectionContent)`
  opacity: 1;
  pointer-events: auto;
  transition: all 500ms ease-in-out;

  @media only screen and (max-width: 850px) and (min-width: 810px) and (orientation: landscape) {
    /* iPhone XS+ landscape */
    margin-bottom: 20px;
  }
`;

export const IntroBgVideo = styled.div`
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: auto;
  transition: all 500ms ease-in-out;

  video {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center center;

    /* Video cover fix for IE11 */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      height: auto;
      left: 50%;
      min-width: 100%;
      min-height: 100%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: auto;
    }
    /* Video cover fix for Edge */
    @supports (-ms-ime-align: auto) {
      height: auto;
      left: 50%;
      min-height: 100%;
      min-width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: auto;
    }
  }
`;

export const PlayButton = styled.button`
  appearance: none;
  background: rgba(255, 255, 255, 0)
    url('/public-assets/images/dream-to-reality/play-icon.svg') 24px 21px
    no-repeat;
  background-size: 31px auto;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: block;
  left: 50%;
  height: 77px;
  margin: -38.5px 0 0 -38.5px;
  opacity: 1;
  pointer-events: auto;
  position: absolute;
  top: 50%;
  transition: all 300ms ease-in-out;
  width: 77px;
  z-index: 2;

  :hover {
    background: rgba(255, 255, 255, 0.3)
      url('/public-assets/images/dream-to-reality/play-icon.svg') 24px 21px
      no-repeat;
    background-size: 31px auto;
  }
  :focus {
    border: 2px solid #1277c6;
    outline: 0;
  }
  @media (max-width: 320px) {
    top: 35%;
  }
  @media (max-width: 500px) {
    top: 40%;
  }
  @media only screen and (max-width: 850px) and (orientation: landscape) {
    left: 75%;
    top: 50%;
  }
  @media only screen and (max-width: 768px) and (orientation: landscape) {
    left: 50%;
    top: 15%;
  }
`;

/* added this for the smokey modal that the you tube video is inside */
export const YouTubeModal = styled.div`
  .modal-component {
    z-index: 35; /* I had to set this because the z-index for some things on this page were at least z-index 25 */
  }
  .modal-container {
    width: 90%;
    height: 90%;
  }
  .modal-content {
    width: 100%;
    height: 100%;
    max-height: unset;
  }
`;

export const YouTubeWrapper = styled.div`
  background-color: #000;
  height: 100%;
  /* margin-top: 55px; */ /* put this back if using react-modal box from old site */
  position: relative;

  div {
    height: 100%;
    width: calc(100% - 24px);
  }
  iframe {
    border: none;
    height: calc(100% - 70px);
    margin-top: 10px;
    width: 100%;
  }

  /* put this back if using react-modal box from old site */
  /* @media only screen and (min-width: 1050px){
      margin-top: 70px;
   } */
`;

export const YouTubeInner = styled.div`
  height: 100%;
  overflow: hidden;
  width: 100%;
`;

export const ScrollWrapper = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 20;
  width: 100%;
  text-align: center;
  letter-spacing: 1px;
  font-size: 12px;
  font-weight: 100;
  cursor: pointer;
`;

export const ScrollText = styled.div`
  color: white;
`;

export const ScrollButton = styled.div`
  width: 20px;
  height: 8px;
  background: url('/public-assets/images/dream-to-reality/arrow.svg') no-repeat
    top left;
  background-size: contain;
  margin: 5px auto 0px auto;
`;
